import { render, staticRenderFns } from "./InfoMercadoPage.vue?vue&type=template&id=236755a9&"
import script from "./InfoMercadoPage.vue?vue&type=script&lang=js&"
export * from "./InfoMercadoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports